//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    middleware: ['isValidTokenID'],

    asyncData({ params }) {
        return {
            id: parseInt(params.id)
        };
    },

    data() {
        return {
            searchText: '',
            search: null,
            items: [],
            showFullscreenPreview: false,
            myTokens: [],
            liked: false,
            blockchain: null,
            connectIndex: 0,
            sellingPrices: [],
            yourSelected: [],
            buySelected: [],
            changedPrices: [],
            selectedAllYour: 0,
            selectedAll: 0,
            selectedId: [],
            showPreviewDialog: 0,
            windowWidth: 0,
            updateYoursDialog: false,
            updateBuyDialog: false,
            wasChanged: false,
            wasBuyed: false,
            buyedTotalPrice: 0,
            tx: '',
            errorText: '',
            sortBuyPrice: 0,
            sortBuyID: 0,
            showingBuy: 5,
            progressValue: 20,
            showAlert: false
        };
    },

    head() {
      return {
        title: "Decentral-Art Details for pieces #"+this.id,
        meta: [
          {
            hid: 'description',
            name: 'description',
            content: 'Decentral-Art are 10,927 collectible characters on the Ethereum blockchain. These are the details for pieces #'+this.id
          }
        ]
      }
    },

    watch: {
        searchText(val) {
            const addresses = [];
            const tokens = [];

            if (val == '' || val == null) {
                this.items = [];
                return;
            }

            if (val.indexOf('Wallet: ') == 0) val = val.substring(8);
            if (val.indexOf('Token ID: ') == 0) val = val.substring(10);
            if (this.isLoading) return;

            this.isLoading = true;

            this.sortedTokens.map((item, i) => {
                if (val.length <= 5 && item.id == val) {
                    tokens.push({
                        name: 'Token ID: ' + item.id,
                        item,
                        data: { type: 'token', val: item.id }
                    });
                } else if (val.length > 5 && item.address.includes(val)) {
                    const found = addresses.find(element => element.item.address === item.address);

                    if (!found) {
                        addresses.push({
                            name: 'Wallet: ' + item.address,
                            item,
                            data: { type: 'wallet', val: item.address }
                        });
                    }
                }
            });

            this.isLoading = false;

            this.items = [...tokens.slice(0, 3), ...addresses.slice(0, 3)];
        }
    },

    computed: {        
        somethingToBuyOrSell(){
            let count = 0;
            this.tokens.map((t) => {
                if(t.sellingPrice > 0) count++;
            })
            return count;
        },

        tokenPrice() {
            return this.$store.getters['token/indexesToSell'].indexOf(this.id) == -1
                ? 0
                : this.$store.getters['token/forSell'][this.id];
        },

        tokenOwnerIndex() {
            for (var i = this.token.owning.length - 1; i >= 0; i--) {
                if (typeof this.token.owning[i][this.id] != 'undefined') {
                    return i;
                }
            }

            return -1;
        },

        tokenOwner() {
            return this.tokenOwnerIndex == -1 ? '' : this.token.indexes[this.tokenOwnerIndex];
        },

        isYourToken() {
            return this.tokenOwner == this.$store.state.web3.account;
        },

        showOverlay() {
            return this.token.loading;
        },

        token() {
            return this.$store.state.token;
        },

        blockchainData() {
            if (this.blockchain) return this.blockchain.getData();
            else return false;
        },

        totalBuyPrice() {
            let totalPrice = 0;
            this.buySelected.map(a => {
                totalPrice += this.sellingPrices[a];
            });
            return totalPrice;
        },

        link() {
            return 'https://explorer.decentral-art.com/tx/' + this.tx;
        },

        sortedTokens() {
            const { items, search } = this;

            if (search !== null && items.length) {
                return items.map(({ item }) => {
                    return item;
                });
            }

            return this.tokens.sort((a, b) => {
                if (this.sortBuyPrice > 0) {
                    if (this.sortBuyPrice == 1) return b.sellingPrice - a.sellingPrice;
                    else return a.sellingPrice - b.sellingPrice;
                } else {
                    if (this.sortBuyID == 1) return b.id - a.id;
                    else return a.id - b.id;
                }
            });
        },

        tokens() {
            if (this.tokenOwnerIndex == -1) return [];
            else {
                let selTokens = [];
                Object.keys(this.token.owning[this.tokenOwnerIndex]).map(id => {
                    selTokens.push({
                        id: parseFloat(id),
                        sellingPrice: this.token.owning[this.tokenOwnerIndex][id],
                        address: this.tokenOwner
                    });
                });
                return selTokens;
            }
        }
    },

    methods: {
        imageSrc(id) {
            if(!this.$DB[id]) return "";
            if(this.token.vipIndexes.indexOf(id) == -1){
                return "https://api.decentral-art.com/token-preview/"+id+"/ordinary";
            }
            return "https://api.decentral-art.com/token-preview/"+id+"/vip";
        },

        buttonHref(sellingPrice, isYourToken, id) {
            if (isYourToken) {
                return `/after-market?sell=${id}`;
            } else {
                return sellingPrice === 0 ? `/preview/details/${id}` : `/after-market?buy=${id}`;
            }
        },

        buttonColor(sellingPrice, isYourToken) {
            if (isYourToken) {
                return sellingPrice === 0 ? '#6200EE' : '#8F46F6';
            }
        },

        buttonText(sellingPrice, isYourToken) {
            if (isYourToken) {
                return sellingPrice === 0 ? this.$t('buttons.sell') : this.$t('buttons.change');
            } else {
                return sellingPrice === 0 ? 'more' : this.$t('buttons.buy');
            }
        },

        async copyURL(url) {
            try {
                await this.$copyText(url);
            } catch (e) {
                console.error(e);
            }

            this.showAlert = true;

            setTimeout(() => {
                this.showAlert = false;
            }, 900);
        },

        goToAfterMarket() {
            location.href = '/after-market?buy=' + this.buySelected.join(',');
        },

        changePrice() {
            location.href = '/after-market?sell=' + this.yourSelected.join(',');
        },

        screenWidth(e) {
            this.windowWidth = e.currentTarget.innerWidth;
        },

        showProgressBar() {
            let interval = setInterval(() => {
                this.progressValue += 20;
                if (this.progressValue >= 100) {
                    clearInterval(interval);
                }
            }, 100);
        },

        preview(a) {
            this.selectedId = [a];
            this.showPreviewDialog++;
        },

        bubleSell() {
            if (this.yourSelected.length == 0) this.selectedAll = 0;
            else if (this.tokens.length != this.yourSelected.length) {
                this.selectedAll = 2;
            } else {
                this.selectedAll = 1;
            }
        },

        bubleBuy() {
            let compare = this.isYourToken? this.tokens.length : this.somethingToBuyOrSell;
            if (this.buySelected.length == 0) this.selectedAll = 0;
            else if (compare != this.buySelected.length) {
                this.selectedAll = 2;
            } else {
                this.selectedAll = 1;
            }
        },

        selectAllToSell() {
            if (this.selectedAll == 0 || this.selectedAll == 2) {
                this.selectedAll = 1;
            } else {
                this.selectedAll = 0;
            }

            const selectedTokens = this.tokens.map(a => a.id);

            this.yourSelected = this.selectedAll == 1 ? selectedTokens : [];
        },

        allBuy() {
            if (this.selectedAll == 0 || this.selectedAll == 2) {
                this.selectedAll = 1;
            } else {
                this.selectedAll = 0;
            }

            const selectedTokens = this.tokens
                .filter(a => {
                    if (a.sellingPrice > 0) {
                        return a.id;
                    }
                })
                .map(a => a.id);

            this.buySelected = this.selectedAll == 1 ? selectedTokens : [];
        },

        getObject(b) {
            this.blockchain = b;
        },

        metamaskUpdated(s) {}
    },

    destroyed() {
        window.removeEventListener('resize', this.screenWidth);
    },

    mounted() {
        this.showProgressBar();

        window.addEventListener('resize', this.screenWidth);
        this.windowWidth = window.innerWidth;
    }
};
